import {
    ButtonLink,
    ButtonPrimary,
    ButtonSecondary,
    Callout,
    Divider,
    IconCalendarRegular,
    IconCallLandlineRegular,
    IconInformationUserRegular,
    IconLocationMapRegular,
    IconOpticalFiberRegular,
    IconWarningRegular,
    PhoneNumberField,
    Spinner,
    Text1,
    Text2,
    TextLink,
    skinVars,
    useDialog,
} from '@telefonica/mistica';
import { AppointmentInfo, ContactInfo } from '../../models/Orders';
import './index.scss';
import { t } from 'i18next';
import { cancelAppointment, getAvailableAppointments, updateAppointmentContact } from '../../services/OrderService';
import { saveModifyAppointmentInfo } from '../../pages/profile/orders/appointmentStorage';
import navigateParams from '../../utils/navigation/navigateParams';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { setInfoError } from '../../utils/dataTransformation/errorMesssages';
import dayjs from 'dayjs';
import { AppointmentStatusTag } from '../../pages/profile/orders/statusTags';
import { useEffect, useState } from 'react';

export const AppointmentInfoSection = ({
    appointmentInfo,
    orderDescription,
    scheduledFiberTransferDate,
    orderId,
}: {
    appointmentInfo: AppointmentInfo;
    orderDescription: string;
    scheduledFiberTransferDate: string;
    orderId: string;
}) => {
    const { dialog } = useDialog();
    const navigate = useNavigate();
    const [valueMobile, setValueMobile] = useState<string>();
    const [array, setArray] = useState<boolean[]>([false]);
    let arrayEdit: boolean[] = Array.from({ length: appointmentInfo?.contactInfo?.length }, () => true);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setArray(arrayEdit);
    }, []);

    const sendToNative = (url: string, description: string, type: string, err?: any, title?: string) => {
        if (url === '/order-detail/modify-appointment') {
            const storage = {
                orderDescription: orderDescription,
                address: appointmentInfo.address,
                workId: appointmentInfo.workId,
                appointmentId: appointmentInfo.appointmentId,
            };
            const queryParams = {
                title: title,
                id: orderId,
            };
            setLoading(true);
            getAvailableAppointments(appointmentInfo.workId).then((response) => {
                const slots = response.data;
                const sortedSlots = slots.sort(
                    (a, b) => new Date(a.startInterval).getTime() - new Date(b.startInterval).getTime(),
                );
                saveModifyAppointmentInfo(orderDescription, appointmentInfo, sortedSlots);
                setLoading(false);

                if (navigateParams(type, url, queryParams, storage, title)) {
                    navigate(`${url}?id=${orderId}`, {
                        state: {
                            stateFeedback: description,
                            err: err,
                        },
                    });
                }
            });
        } else if (url === '/order-detail/required-equipment') {
            const queryParams = {
                title: title,
                id: orderId,
            };
            if (navigateParams(type, url, queryParams, {}, title)) {
                navigate(`${url}?id=${orderId}`);
            }
        } else {
            const isSuccess = description === 'SUCCESS';
            const storage = {
                orderDescription: orderDescription,
                address: appointmentInfo.address,
                workId: appointmentInfo.workId,
                appointmentId: appointmentInfo.appointmentId,
            };
            const queryParams = {
                title: isSuccess ? t('rehabilitationLinesInfoFeedbackTitle') : t('profileFeedbackErrorTitle'),
                subtitle: isSuccess ? t('successFeedbackCancelAppointment') : t('errorFeedbackDescriptionConfirmDate'),
                state: description,
                errorCode: err ? `${t('codeError')}: #${err.id}` : '',
                id: orderId,
            };
            if (navigateParams(type, url, queryParams, storage, title)) {
                navigate(`${url}?id=${orderId}`, {
                    state: {
                        stateFeedback: description,
                        err: err,
                    },
                });
            }
        }
    };

    const cancelAppointmentButton = () => {
        cancelAppointment(appointmentInfo?.workId, appointmentInfo?.appointmentId)
            .then(() => {
                sendToNative('/order-detail/cancel/feedback', 'SUCCESS', 'feedback-success');
            })
            .catch((error: AxiosError) => {
                sendToNative('/order-detail/cancel/feedback', 'ERROR', 'feedback-error', setInfoError(error));
            });
    };

    const editrArrayEdit = (index: number, number: string) => {
        setValueMobile(number);
        arrayEdit[index] ? (arrayEdit[index] = false) : (arrayEdit[index] = true);
        setArray(arrayEdit);
    };

    const updateContact = (contact: ContactInfo) => {
        const newContact: ContactInfo = {
            id: contact.id,
            alias: contact.alias,
            number: valueMobile!,
        };
        updateAppointmentContact(newContact).then(() => {
            window.location.reload();
        });
    };

    return (
        <>
            {loading ? (
                <div className='c-spinner'>
                    <Spinner size={24} />
                    <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
                </div>
            ) : (
                <div className='appinmentInfo-component'>
                    <div className='appinmentInfo-component__title'>
                        <IconOpticalFiberRegular size={24} color={skinVars.colors.textSecondary} />
                        <div className='appinmentInfo-component__title-text'>
                            <Text1 medium color={skinVars.colors.textSecondary}>
                                {t('appoinmetInfoTitle')}
                            </Text1>
                        </div>
                    </div>

                    <div className='appinmentInfo-component__content'>
                        <div className='appinmentInfo-component__content-calendar'>
                            <div className='appinmentInfo-component__content-calendar-info'>
                                <div className='appinmentInfo-component__content-calendar-info-icon'>
                                    <IconCalendarRegular size={24} color={skinVars.colors.brandHigh} />
                                </div>

                                {appointmentInfo.status === 'UNSCHEDULED' ? (
                                    <div
                                        className='appinmentInfo-component__content-calendar-info-text'
                                        style={{ display: 'flex', alignItems: 'center' }}
                                    >
                                        -
                                    </div>
                                ) : (
                                    <div className='appinmentInfo-component__content-calendar-info-text'>
                                        <Text2 regular>
                                            {scheduledFiberTransferDate
                                                ? dayjs(scheduledFiberTransferDate).format('DD/MM/YYYY')
                                                : dayjs(appointmentInfo.startInterval).format('DD/MM/YYYY')}
                                        </Text2>
                                        <div>
                                            {scheduledFiberTransferDate ? (
                                                <Text2 regular>
                                                    {dayjs(scheduledFiberTransferDate).format('HH:mm')}
                                                </Text2>
                                            ) : (
                                                <Text2 regular>
                                                    {dayjs(appointmentInfo.startInterval).format('HH:mm')}-
                                                    {dayjs(appointmentInfo.endInterval).format('HH:mm')} h
                                                </Text2>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className='appinmentInfo-component__content-calendar-tag'>
                                {<AppointmentStatusTag status={appointmentInfo.status}></AppointmentStatusTag>}
                            </div>
                        </div>
                        <div className='appinmentInfo-component__content-address'>
                            <div className='appinmentInfo-component__content-address-icon'>
                                <IconLocationMapRegular size={24} color={skinVars.colors.brandHigh} />
                            </div>

                            <div className='appinmentInfo-component__content-address-text'>
                                <Text2 regular>{appointmentInfo.address}</Text2>
                            </div>
                        </div>

                        {appointmentInfo.contactInfo?.length > 0 &&
                            appointmentInfo.contactInfo.map((contact, index) => (
                                <div className='appinmentInfo-component__content-contact' key={index}>
                                    {array[index] ? (
                                        <>
                                            <IconCallLandlineRegular
                                                size={24}
                                                color={skinVars.colors.brandHigh}
                                                style={{ transform: 'rotate(90deg)' }}
                                            />
                                            <div className='appinmentInfo-component__content-contact-number'>
                                                <Text2 regular>{contact.number}</Text2>
                                            </div>

                                            <TextLink
                                                style={{ color: `${skinVars.colors.brand}` }}
                                                onPress={() => {
                                                    if (
                                                        appointmentInfo.status === 'UNSCHEDULED' ||
                                                        appointmentInfo.status === 'SCHEDULED'
                                                    ) {
                                                        editrArrayEdit(index, contact.number);
                                                    }
                                                }}
                                                disabled={
                                                    appointmentInfo.status === 'CANCELED' ||
                                                    appointmentInfo.status === 'EXPIRED' ||
                                                    appointmentInfo.status === 'DONE'
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <Text2 medium color={skinVars.colors.textLink}>
                                                    {t('contactVerificationStep1ButtonEdit')}
                                                </Text2>
                                            </TextLink>
                                        </>
                                    ) : (
                                        <div className='appinmentInfo-component__content-contact-input' key={index}>
                                            <PhoneNumberField
                                                value={valueMobile}
                                                name='editNumber'
                                                label='Telefono de contacto'
                                                onChangeValue={setValueMobile}
                                            />

                                            <TextLink
                                                style={{ width: '100px', marginLeft: '12px' }}
                                                onPress={() => {
                                                    updateContact(contact);
                                                }}
                                                disabled={valueMobile?.length === 9 ? false : true}
                                            >
                                                <Text2 color={skinVars.colors.textLink} medium>
                                                    {t('save')}
                                                </Text2>
                                            </TextLink>
                                        </div>
                                    )}
                                </div>
                            ))}
                        {appointmentInfo.status === 'SCHEDULED' && (
                            <div className='appinmentInfo-component__content-buttons'>
                                <div className='appinmentInfo-component__content-buttons-primary'>
                                    <ButtonPrimary
                                        small
                                        onPress={() => {
                                            sendToNative(
                                                '/order-detail/modify-appointment',
                                                '',
                                                'modeFlow-backgroundBlue',
                                                '',
                                                t('modifyAppointment'),
                                            );
                                        }}
                                    >
                                        {t('modifyAppointment')}
                                    </ButtonPrimary>
                                </div>
                                <ButtonSecondary
                                    small
                                    onPress={() => {
                                        dialog({
                                            icon: <IconWarningRegular size={40} color={skinVars.colors.brand} />,
                                            title: t('cancelFiberInstallationAppointment'),
                                            message: t('confirmCancelAppointment'),
                                            acceptText: t('supportIncidentDetailBtnCancel'),
                                            onAccept: () => {
                                                cancelAppointmentButton();
                                            },
                                            onCancel() {},
                                            cancelText: t('changesPasswordErrorFeedbackButton'),
                                        });
                                    }}
                                >
                                    {t('cancelFiberInstallationAppointment')}
                                </ButtonSecondary>
                            </div>
                        )}
                    </div>
                    {scheduledFiberTransferDate && (
                        <div className='appinmentInfo-component__callout'>
                            <Callout
                                icon={<IconInformationUserRegular color={skinVars.colors.brand} size={24} />}
                                title={t('appoinmetInfoCallOutTitle')}
                                description={t('appoinmetInfoCallOutDescription')}
                                buttonLink={
                                    <ButtonLink
                                        onPress={() => {
                                            sendToNative(
                                                '/order-detail/required-equipment',
                                                '',
                                                'modeFlow-backgroundBlue',
                                                '',
                                                t('transferInformation'),
                                            );
                                        }}
                                    >
                                        {t('appoinmentInfoCallOutBtnLink')}
                                    </ButtonLink>
                                }
                            ></Callout>
                        </div>
                    )}
                    <div className='appinmentInfo-component__divider'>
                        <Divider />
                    </div>
                </div>
            )}
        </>
    );
};
